// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "checkbox_checked-2gdk7";
var _4 = "checkbox-6b7bm";
var _5 = "label-3P1sd";
var _6 = "rules-337yb";
var _7 = "tooltip-2zXsD";
var _8 = "rules__label-2evou";
var _9 = "rules__tooltip-WCwTS";
var _a = "terms-cMOrW";
var _b = "toolbarCheckbox__wrapper-1lA0i";
var _c = "root-3x9cb";
export { _1 as "__esModule", _2 as "mobile", _3 as "checkbox_checked", _4 as "checkbox", _5 as "label", _6 as "rules", _7 as "tooltip", _8 as "rules__label", _9 as "rules__tooltip", _a as "terms", _b as "toolbarCheckbox__wrapper", _c as "root" }
export default { "__esModule": _1, "mobile": _2, "checkbox_checked": _3, "checkbox": _4, "label": _5, "rules": _6, "tooltip": _7, "rules__label": _8, "rules__tooltip": _9, "terms": _a, "toolbarCheckbox__wrapper": _b, "root": _c }
